var app = angular.module("leonardo");

var ReportsList = function($scope, $controller, $filter, $window, ngDialog, ReportService, PropertyService, FilterService,
                           DynamicFormRestService, AttachmentService, TemplateService, TaskService) {


  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Action Items Reports');
  $scope.report_type = ReportService.TYPE_ACTION_ITEM;
  $scope.fieldsReport = ReportService.fieldsReport;
  $scope.IdFields = ReportService.actionItemsIdFields;

  $scope.resetFields = function(){
    if (FilterService.hasFilter('extra_fields')) {
      $scope.extra_fields = FilterService.getFilter('extra_fields').split(',');
    }
    else {
      $scope.extra_fields = [];
    }

    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else {
      $scope.fields_active = ReportService.defaultActionItemsFields;
    }
    FilterService.setFilter('fields_active', $scope.fields_active.join(','));
  };

  $scope.hasImportants = function(item) {
    var has = false;
    angular.forEach(item.notes, function(note) {
      if (note.important) {
        has = true;
      }
    });
    return has;
  };

  $scope.getIndexRecurrence = function(id, recurrence_id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped[$scope.getIndex(id)].recurrences, function(value, key){
      if (value.recurrence_type == recurrence_id) {
        index = key;
      }
    });
    return index;
  };

  $scope.getFieldClasses = function(field){
    var classes = [];
    switch (field) {
      case 'action_item': classes.push('field-name');
        break;
      case 'notes':
      case 'cannot_do_notes':
        classes.push('field-note');
        break;
      case 'note_add_by': classes.push('field-note-user');
        break;
      case 'users': classes.push('field-note-user');
        break;
      case 'template_attachments':
      case 'notes_attachments':
      case 'attachments':
        classes.push('field-media');
        break;
      case 'due_date':
      case 'completed_date':
        classes.push('date-multi-head');
        break;
    }
    return classes;
  };

  $scope.getDevice = function (type) {
    if (!isNull(type)) {
      switch (type.toString()) {
        case TaskService.DEVICE_TYPE_DESKTOP:
          return 'icon-computer.svg';
        case TaskService.DEVICE_TYPE_IOS:
          return 'icon-apple.svg';
        case TaskService.DEVICE_TYPE_ANDROID:
          return 'icon-android.svg';
      }
    }
    return 'icon-computer.svg';
  };

  $scope.getCompletedOnDevice = function (type, count) {
    var html = '<div><icon class="icon-device icon" icon-image="' + $scope.getDevice(type) + '" icon-color="secondaryColor" icon-width="15" icon-height="15"></icon>';
    if (!isNull(type)) {
      switch (type.toString()) {
        case TaskService.DEVICE_TYPE_IOS:
          html += '<span class="device-name">ios</span>';
          break;
        case TaskService.DEVICE_TYPE_ANDROID:
          html += '<span class="device-name">android</span>';
          break;
        default:
          html += '<span class="device-name">desktop</span>';
          break;
      }
    }
    if (!isNull(count)) {
      html += '<span class="device-name">: ' + count + '</span>';
    }
    return html + '</div>';
  };

  $scope.getCompletedPosition = function (position) {
    return '<div><a href="https://www.google.com/maps/search/?api=1&query='+position.latitude+','+position.longitude+'" target="_blank">' + position.latitude + ', ' + position.longitude +'</a></div>';
  };

  $scope.OpenLogsPDF = function (id) {
    TaskService.getApprovalLogPDF(id).then(function (url) {
      $window.open(url, '_blank');
    });
  }

  $scope.getFieldValue = function(report, field) {
    var html = '';
    switch(field) {
      case 'action_item':
        return report.name;
      case 'due_date':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function(date){
            html += '<span class="date-multi">' + moment(date).format('MMM DD, YYYY') + '</span>';
          });
        }
        else if (report[field]) {
          html = moment(report[field]).format('MMM DD, YYYY');
        }
        return html;
      case 'completed_date':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function(date){
            var date_aux = date.split('.');
            html += '<span class="date-multi">' + moment(date_aux[0]).format('MMM DD, YYYY') + '</span>';
          });
        }
        else if (report[field]) {
          var date_aux1 = report[field].split('T');
          html = moment(date_aux1[0]).format('MMM DD, YYYY');
        }
        return html;
      case 'notes':
        html = '';
        angular.forEach(report.notes, function(note){
          if(!([ReportService.STATUS_CANNOT_DO, ReportService.STATUS_DISMISS].includes(note.type?.toString()))) {
          html += '<span>' + '* ' + note.text + ' (' + moment(note.created).format("MMM DD, YYYY") + ').' + '</span>';
          }
        });
        return html;
      case 'cannot_do_notes':
        html = '';
        angular.forEach(report.notes, function(note){
          if([ReportService.STATUS_CANNOT_DO, ReportService.STATUS_DISMISS].includes(note.type?.toString())) {
            html += '<span>' + '* ' + note.text + ' (' + moment(note.created).format("MMM DD, YYYY") + ').' + '</span>';
          }
        });
        return html;
      case 'note_add_by':
        html = '';
        angular.forEach(report.notes, function(note){
          if (note.user) {
            html += '<span>' + $filter("username")(note.user) + '</span>';
          }
        });
        return html;
      case 'account_users_assigned':
        html = '';
        angular.forEach(report.account_users_assigned, function(account_user){
          html += '<span>' + $filter("username")(account_user.user) + '</span>';
        });
        return html;
      case 'made_by':
      case 'snoozed_by':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function(account_user){
            html += '<span>' + $filter("username")(account_user.user) + '</span>';
          });
        }
        else
          if (report[field]) {
            html = '<span>' + $filter("username")(report[field].user) + '</span>';
          }
        return html;
      case 'notes_important':
        return $scope.hasImportants(report) ? 'YES' : '';
      case 'notes_attachments':
      case 'template_attachments':
        html = '';
        angular.forEach((field == 'notes_attachments' ? report.notes_attachments : report.template_attachments), function (attachment) {
          attachment.file = attachment.document_file ? attachment.document_file.signed_view_url : (attachment.signed_view_url || attachment.file);
          var href = attachment.link ? attachment.link : attachment.file;
          if (AttachmentService.getClassesAttachment(attachment) === 'folder') {
            html += '<span><a ui-sref="documents.list({pk:' + attachment.document_folder.id + '})" target="_blank">';
          }
          else {
            html += '<span><a href="' + href + '" target="_blank">';
          }
          if (AttachmentService.getClassesAttachment(attachment) === 'folder') {
            html += '<icon class="icon" icon-image="icon-folder.svg" icon-width="18" icon-height="18" icon-color="secondaryColor"></icon>';
          }
          if (AttachmentService.getClassesAttachment(attachment) === 'image') {
            html += '<img src="' + href + '"/>';
          }
          else {
            html += attachment.name;
          }
          html += '</a></span>';
        });
        return html;
      case 'priority':
        return $filter('priority')(report.priority);
      case 'completed_on_device':
        html = '';
        if (angular.isObject(report.completed_on_device)) {
          angular.forEach(Object.keys(report.completed_on_device), function (key){
            html += $scope.getCompletedOnDevice(key, report.completed_on_device[key]) + '\n';
          })
        }
        else {
          html += $scope.getCompletedOnDevice(report.completed_on_device);
        }
        return html;
      case 'completed_position':
        html = '';
        if(!isEmpty(report.completed_position)){
          if (angular.isArray(report.completed_position)) {
            angular.forEach(report.completed_position, function (position) {
              html += $scope.getCompletedPosition(position);
            });
          }
          else {
            html += $scope.getCompletedPosition(report.completed_position);
          }
        }
        return html;
      case 'marked_dismiss':
        if (!isNull(report.status)) {
          return report.status.toString() === ReportService.STATUS_DISMISS ? 'YES': '';
        }
        else {
          return '';
        }
      case 'cannot_do':
        if (!isNull(report.status)) {
          return report.status.toString() === ReportService.STATUS_CANNOT_DO ? 'YES': '';
        }
        else{
          html = '';
          if (angular.isArray(report.completed_date)) {
            angular.forEach(report.completed_date, function(date){
              html += '<span>' + moment(date).format('MMM DD, YYYY') + '</span>';
            });
          }
          else if (report.completed_date) {
            html = moment(report.completed_date).format('MMM DD, YYYY');
          }
          return html;
        }
      case 'dynamic_form':
        html = '';
        if (report.dynamic_form_data) {
          if (!angular.isArray(report.dynamic_form_data)) {
            html = '<span class="link" ng-click="openDynamicFormDialog(report)">' + report.dynamic_form_data.dynamic_form.name +'</span>';
          }
          else {
            angular.forEach(report.dynamic_form_data, function(dynamic_form_data){
              html += '<span class="link" ng-click="openDynamicFormDialog(report, ' + dynamic_form_data.id + ')">' + dynamic_form_data.dynamic_form.name +'</span>';
            });
          }
        }
        return html;
      case 'approval_log':
        html = '';
        if (report.has_approval_log) {
          html = '<span class="link" ng-click="OpenLogsPDF(report.id)">PDF</span>';
        }
        return html;
      case 'account':
      case 'portfolio':
      case 'property':
        return report[field] ? report[field].name : '';
      case 'building':
        return report.unit ? report.unit.building : '';
      case 'unit':
        return report.unit ? report.unit.number : '';
      case 'unit_type':
        return report.unit ? report.unit.type : '';
      case 'groups':
      case 'managed_by':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (element) {
            html += '<span>' + element.name + '</span>';
          });
          return html;
        }
        else {
          if (report[field]) {
            html = report[field].name;
            return html;
          }
          html = (field === 'managed_by') ? 'Only Owner' : ''
          return html;
        }
      default: return report[field];
    }
  };

  $scope.openDynamicFormDialog = function (report, dynamic_form_data_id) {
    var task = angular.copy(report);
    task.status = [TaskService.STATUS_PENDING].includes(task.status?.toString()) ? TaskService.STATUS_SOLVED : task.status;
    PropertyService.get(report.property.id).then(function (property) {
      if (dynamic_form_data_id) {
        angular.forEach(report.dynamic_form_data, function (data) {
          if (data.id == dynamic_form_data_id) {
            ngDialog.openConfirm({
              template: 'views/templates/dialog/task/dynamic-form-react.html',
              className: 'ngdialog-theme-default ngdialog-dynamic-form',
              controller: 'TaskDynamicFormDialogReact',
              resolve: {
                formObj: [function () {
                  return data.dynamic_form;
                }],
                formDataObj: ['DynamicFormDataRestService', function (DynamicFormDataRestService) {
                  return DynamicFormDataRestService.get(data.id);
                }]
              },
              data: {
                task: task,
                approvalStatus: false,
                property: property,
                mode: 'read',
                print: true,
              }
            }).then(function (result) {
              callback(result);
            });
          }
        });
      }
      else {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/task/dynamic-form-react.html',
          className: 'ngdialog-theme-default ngdialog-dynamic-form',
          controller: 'TaskDynamicFormDialogReact',
          resolve: {
            formObj: [function () {
              return report.dynamic_form_data.dynamic_form;
            }],
            formDataObj: ['DynamicFormDataRestService', function (DynamicFormDataRestService) {
              return DynamicFormDataRestService.get(report.dynamic_form_data.id);
            }]
          },
          data: {
            task: task,
            approvalStatus: false,
            property: property,
            mode: 'read',
            print: true,
          }
        }).then(function (result) {
          callback(result);
        });
      }
    });
  };

  $scope.concatRecurrence = function (report) {
    var id = null;
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        if (report.account) {
          id = report.account.id;
        }
        break;
      case 'portfolio':
        if (report.portfolio) {
          id = report.portfolio.id;
        }
        break;
      case 'property':
        if (report.property) {
          id = report.property.id;
        }
        break;
    }
    var recurrence = $scope.reportsGrouped[$scope.getIndex(id)].recurrences[$scope.getIndexRecurrence(id, report.recurrence_type)].recurrence;
    angular.forEach(report.recurrence, function(value, key){
      if (value && _.contains(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'], key)){
        recurrence[key] = value;
      }
    });
    $scope.reportsGrouped[$scope.getIndex(id)].recurrences[$scope.getIndexRecurrence(id, report.recurrence_type)].recurrence = recurrence;
  };

  $scope.groupReports = function(data) {
    if (data.results){
      $scope.reports = data.results.data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    if (_.contains($scope.fields_active, 'attachments')) {
      angular.forEach($scope.reports, function(value) {
        value.attachmentObjects = [];
        angular.forEach(value.notes, function (note) {
          angular.forEach(note.attachments, function (attachment) {
            value.attachmentObjects.push(attachment);
          });
        });
      });
    }
    $scope.reportsGrouped = [];

    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({id: account.id, name: account.name});
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({id: portfolio.id, name: portfolio.name});
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({id: property.id, name: property.name});
          }
        });
        break;
    }
    angular.forEach($scope.reports, function(value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              if(FilterService.hasFilter('group_reports')){
                if(_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())){
                  id.push(group.id);
                  name.push(group.name);
                  array_by_name.push({id: group.id, name: group.name});
                }
              }else{
                id.push(group.id);
                name.push(group.name);
                array_by_name.push({id: group.id, name: group.name});
              }
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({id: manager.id, name: manager.name});
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
      }
      if (angular.isArray(id)){
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, recurrences: []});
          }
          var recur_type = null;
          var recurence = value.recurrence;
          if (!isNull(value.type_task)) {
            switch (value.type_task.toString()) {
              case TaskService.TYPE_TASK_DOCUMENT:
                recur_type = 'document';
                break;
              case TaskService.TYPE_TASK_WORKFLOW:
                recur_type = 'workflow';
                break;
              case TaskService.TYPE_TASK_WORK_ORDER:
                recur_type = 'work-order';
                break;
              default:
                recur_type = (value.recurrence_type == TemplateService.RECURRENCE_FIXED_DATE) ?
                  TemplateService.RECURRENCE_DAILY : value.recurrence_type;
                break;
            }
          }
          if ($scope.getIndexRecurrence(value_manager.id, recur_type) < 0) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].recurrences.push({recurrence_type:recur_type, reports: [], recurrence: recurence });
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].recurrences[$scope.getIndexRecurrence(value_manager.id, recur_type)].reports, value.id) < 0) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].recurrences[$scope.getIndexRecurrence(value_manager.id, recur_type)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, recurrences: []});
        }
        var recurrence_type = null;
        var recurrence = value.recurrence;
        if (!isNull(value.type_task)) {
          switch (value.type_task.toString()) {
            case TaskService.TYPE_TASK_DOCUMENT:
              recurrence_type = 'document';
              break;
            case TaskService.TYPE_TASK_WORKFLOW:
              recurrence_type = 'workflow';
              break;
            case TaskService.TYPE_TASK_WORK_ORDER:
              recurrence_type = 'work-order';
              break;
            default:
              recurrence_type = (value.recurrence_type == TemplateService.RECURRENCE_FIXED_DATE) ?
                TemplateService.RECURRENCE_DAILY : value.recurrence_type;
              break;
          }
        }
        if ($scope.getIndexRecurrence(id, recurrence_type) < 0) {
          $scope.reportsGrouped[$scope.getIndex(id)].recurrences.push({recurrence_type:recurrence_type, reports: [], recurrence: recurrence });
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].recurrences[$scope.getIndexRecurrence(id, recurrence_type)].reports, value.id) < 0) {
          $scope.reportsGrouped[$scope.getIndex(id)].recurrences[$scope.getIndexRecurrence(id, recurrence_type)].reports.push(value);
        }
      }

    });
    angular.forEach($scope.reportsGrouped, function(value){
      var recurrences = [];
      var document = null;
      var workflow = null;
      var work_order = null;
      var daily = null;
      var weekly = null;
      var fix_date = null;
      var monthly = null;
      var yearly = null;
      var other = null;
      angular.forEach(value.recurrences, function(recurrence){
        if (recurrence) {
          if (!isNull(recurrence.recurrence_type)) {
            switch (recurrence.recurrence_type.toString()) {
              case 'document':
                document = recurrence;
                break;
              case 'workflow':
                workflow = recurrence;
                break;
              case 'work-order':
                work_order = recurrence;
                break;
              case TemplateService.RECURRENCE_DAILY:
                daily = recurrence;
                break;
              case TemplateService.RECURRENCE_WEEKLY:
                weekly = recurrence;
                break;
              case TemplateService.RECURRENCE_FIXED_DATE:
                fix_date = recurrence;
                break;
              case TemplateService.RECURRENCE_MONTHLY:
                monthly = recurrence;
                break;
              case TemplateService.RECURRENCE_YEARLY:
                yearly = recurrence;
                break;
            }
          }
          else {
            other = recurrence;
          }
        }
      });
      if (document) {
        recurrences.push(document);
      }
      if (workflow) {
        recurrences.push(workflow);
      }
      if (work_order) {
        recurrences.push(work_order);
      }
      if (weekly) {
        recurrences.push(weekly);
      }
      if (daily) {
        recurrences.push(daily);
      }
      if (fix_date) {
        recurrences.push(fix_date);
      }
      if (monthly) {
        recurrences.push(monthly);
      }
      if (yearly) {
        recurrences.push(yearly);
      }
      if (other) {
        recurrences.push(other);
      }
      value.recurrences = recurrences;
    });
    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };

  $scope.$on('fields-active:reset', $scope.resetFields);

};

app.controller('ReportsList', ['$scope', '$controller', '$filter', '$window', 'ngDialog', 'ReportService', 'PropertyService',
  'FilterService', 'DynamicFormRestService', 'AttachmentService', 'TemplateService', 'TaskService', ReportsList]);
